export default __webpack_public_path__ + "static/media/Three.8a38050c.png";